export default {
  title: 'Möchtest du dich wirklich abmelden?',
  buttons: {
    logout: 'Abmelden',
    cancel: 'Abbrechen',
  },
};
